import { createStore } from "vuex";

// vue stores
import { auth } from "./modules/auth.store";
import { page } from "./modules/page.store";

export const store = new createStore({
    modules: { page, auth },
    plugins: [],
});